module.exports = __webpack_public_path__ + "fonts/Neboma_Sporte.f074955a.ttf";